export const IconSizes = {
  X_SMALL: 'size-xs', // 12
  SMALL: 'size-s', // 16
  MEDIUM: 'size-m', // 20
  LARGE: 'size-l', // 24
  X_LARGE: 'size-xl', // 28
};

export const IconColors = {
  LIGHT: 'color-white',
  DARK: 'color-dark',
  GREY: 'color-grey',
  LIGHT_GREY: 'color-light-grey',
  PRIMARY: 'color-primary',
  DISABLED: 'color-disabled',
  SUCCESS: 'color-success',
  WARNING: 'color-warning',
  ERROR: 'color-error',
};
